import gsap from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

export default function Hero1Tooltips() {
    let resizeTimeout;

    const positionTitleNumbers = () => {
        document.querySelectorAll('.title_item').forEach((item) => {
            const ref = item.dataset.ref;
            const numberEl = item.querySelector('.title_item-number');
            const wordEl = document.querySelector(`.title_word[data-ref="${ref}"]`);

            if (!wordEl || !numberEl) return;

            const rect = wordEl.getBoundingClientRect();
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

            const offsetY = parseInt(item.dataset.offsetNumber, 10) || 20;
            const offsetX = parseInt(item.dataset.offsetNumberX, 10) || 10;

            const top = rect.top + scrollTop - offsetY;
            const left = rect.left + scrollLeft + rect.width + offsetX;

            gsap.set(numberEl, {
                top: `${top}px`,
                left: `${left}px`,
                position: 'absolute'
            });

            gsap.to(numberEl, {
                autoAlpha: 1,
                duration: 0.6,
                ease: "power2.out",
                delay: 0.1
            });
        });
    };

    const setupTooltipHover = () => {
        document.querySelectorAll('.title_word').forEach((wordEl) => {
            const ref = wordEl.dataset.ref;
            const itemEl = document.querySelector(`.title_item[data-ref="${ref}"]`);
            const contentEl = itemEl?.querySelector('.title_item-content');

            if (!contentEl) return;

            const contentInner = contentEl.querySelector('.title_item-content_inner');
            const numberEl = document.querySelector(`.title_item[data-ref="${ref}"] .title_item-number`);

            const split = new SplitText(wordEl, { type: "chars" });
            let leaveTimeout;

            const openTooltip = () => {
                clearTimeout(leaveTimeout);

                if (numberEl) numberEl.classList.add('active');
                if (contentInner) contentInner.classList.add('active');

                gsap.killTweensOf(split.chars);

                split.chars.forEach((char, index) => {
                    gsap.to(char, {
                        duration: 0,
                        delay: index * 0.05,
                        onComplete: () => char.classList.add('active')
                    });
                });

                const rect = wordEl.getBoundingClientRect();
                const scrollTop = window.scrollY;
                const scrollLeft = window.scrollX;
                const offsetY = parseInt(itemEl.dataset.offset, 10) || 110;
                const offsetX = parseInt(itemEl.dataset.offsetX, 10) || 0;
                const TARGET_WIDTH = 450;
                const SCREEN_PADDING = 20;

                let width = Math.min(TARGET_WIDTH, window.innerWidth - (SCREEN_PADDING * 2));
                let left = (rect.left + (rect.width / 2)) - (width / 2) + offsetX;

                if (left < SCREEN_PADDING) left = SCREEN_PADDING;
                if (left + width > window.innerWidth - SCREEN_PADDING) {
                    left = window.innerWidth - SCREEN_PADDING - width;
                }

                let top = rect.bottom + scrollTop - offsetY;

                gsap.set(contentEl, {
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${width}px`,
                    position: 'absolute',
                    zIndex: 100
                });
                contentEl.classList.add('visible');

                gsap.set(contentInner, { pointerEvents: 'none' });
                gsap.fromTo(contentInner,
                    { autoAlpha: 0, y: 20 },
                    {
                        autoAlpha: 1, y: 0, duration: 0.4, ease: 'power3.out', overwrite: 'auto',
                        onComplete: () => { gsap.set(contentInner, { pointerEvents: 'auto' }); }
                    }
                );
            };

            const closeTooltip = () => {
                leaveTimeout = setTimeout(() => {
                    if (numberEl) numberEl.classList.remove('active');
                    if (contentInner) contentInner.classList.remove('active');

                    gsap.killTweensOf(split.chars);
                    split.chars.forEach((char, index) => {
                        gsap.to(char, {
                            duration: 0,
                            delay: index * 0.02,
                            onComplete: () => char.classList.remove('active')
                        });
                    });

                    gsap.to(contentInner, {
                        autoAlpha: 0, y: 20, duration: 0.3, ease: 'power2.in', overwrite: 'auto',
                        onComplete: () => { contentEl.classList.remove('visible'); }
                    });
                }, 100);
            };

            wordEl.addEventListener('mouseenter', openTooltip);
            wordEl.addEventListener('mouseleave', closeTooltip);
            contentEl.addEventListener('mouseenter', () => clearTimeout(leaveTimeout));
            contentEl.addEventListener('mouseleave', closeTooltip);
        });
    };

    const initEntranceAnimation = () => {
        const targets = document.querySelectorAll('.block-hero-home_content .grid_content > *, .block-hero-home_content .grid_logos');
        if (targets.length === 0) return;
        gsap.fromTo(targets,
            { yPercent: 100, autoAlpha: 0 },
            {
                yPercent: 0,
                autoAlpha: 1,
                duration: 1,
                stagger: 0.1,
                ease: "power3.out",
                clearProps: "transform",
                onComplete: () => {
                    requestAnimationFrame(positionTitleNumbers);
                }
            }
        );
    };

    // INIT
    const init = () => {
        setupTooltipHover();
        initEntranceAnimation();
    };

    if (document.fonts) {
        document.fonts.ready.then(() => {
            if (document.readyState === 'complete') {
                init();
            } else {
                window.addEventListener('load', init);
            }
        });
    } else {
        if (document.readyState === 'complete') {
            init();
        } else {
            window.addEventListener('load', init);
        }
    }

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            requestAnimationFrame(positionTitleNumbers);
        }, 100);
    });
}